/*
  bf_turneliminate.ts
  Copyright (c) 2013-present Human Cube Inc.

  Does any player elimination.
*/

import BF from '../bfconst1';
import bfH from '../bf_helper';
import { Game } from '../gameTypes';
import bfTurnReplay from './bf_turnreplay';


function zoneHasLiberators (game: Game, playerIndex: number, zoneID: number) {
  // Returns true if the player or his allies have attacking forces in the zone else false.
  let fixedAlly = 0;
  if( Array.isArray(game.fixedAlly) && game.fixedAlly[playerIndex] ) {
    fixedAlly = game.fixedAlly[playerIndex];
  }
  fixedAlly |= (1 << playerIndex);
  for(let i = 1; i <= game.players; i++) {
    if(fixedAlly & (1 << i)) {
      const len = game.force[i].length;
      for(let j = 0; j < len; j++) {
        const force = game.force[i][j];
        if(force[BF.FORCE_INDEX_ZONE] === zoneID) {
          const forceType = force[BF.FORCE_INDEX_TYPE];
          const forceFlags = game.forceFlags[forceType];
          if(forceFlags & (BF.FORCE_FLAG_IS_AIR_ONLY_TARGET|BF.FORCE_FLAG_IS_SURFACE_ONLY_TARGET)) {
            return true;
          }
        }
      }
    }
  }
  return false;
}


export function doPlayerElimination (game: Game) {

  const eliminate = [];      // Is player tagged for elimination.
  let eliminateCount = 0;  // Players to be eliminated.
  let remainingCount = 0;  // Players remaining count.

  for(let playerIndex = 1; playerIndex <= game.players; playerIndex++) {
    if( game.finished[playerIndex][0] ) {
      continue;  // Player no longer in game (already eliminated).
    }

    const capitalZoneID = game.capital[playerIndex];
    if( capitalZoneID <= 0 || game.zoneOwner[capitalZoneID] !== playerIndex ) {
      // Does not own capital.
      let hasForce = false;
      for(let i = 0; i < game.force[playerIndex].length; i++) {
        if(game.force[playerIndex][i][BF.FORCE_INDEX_ZONE] > 0) {
          let forceType = game.force[playerIndex][i][BF.FORCE_INDEX_TYPE];
          if( game.forceFlags[forceType] &
              (BF.FORCE_FLAG_IS_SURFACE_ONLY_TARGET | BF.FORCE_FLAG_IS_AIR_ONLY_TARGET) ) {
            hasForce = true;
            break;
          }
        }
      }
      if( game.flags & BF.GAME_FLAG_LOSE_CAPITAL_LOSE ) {
        eliminate[playerIndex] = true;
        eliminateCount++;
        continue;
      }

      if( game.flags & BF.GAME_FLAG_MUST_RECAPTURE_CAPITAL ) {
        if(capitalZoneID > 0 &&
            game.zoneOwnerPrev[capitalZoneID] !== playerIndex) {
          // Owner has not owned capital for last two turns.
          // Must be mounting retake or will be eliminated.
          if(!zoneHasLiberators(game, playerIndex, capitalZoneID)) {
            // No player or ally counter-attackers so destroy this player.
            eliminate[playerIndex] = true;
            eliminateCount++;
            continue;
          }
        }
      }

      if( !hasForce ) {  // Does not have any forces left.
        eliminate[playerIndex] = true;
        eliminateCount++;
        continue;
      }
      remainingCount++;
    }
    else remainingCount++;
  }

  if(eliminateCount > 0) {
    for(let playerIndex = 1; playerIndex <= game.players; playerIndex++) {
      if(eliminate[playerIndex]) {
        bfTurnReplay.eliminate(game, playerIndex);
        bfH.eliminatePlayer(game, playerIndex);
        // Players eliminated in the same turn will get the same rank.
        game.finished[playerIndex][0] = remainingCount + eliminateCount;
        game.finished[playerIndex][1] = game.turn;
      }
    }
  }
}
